import { defineMessages } from 'react-intl'

const scope = `procurify.expenses.ExpenseStatusPage`

export default defineMessages({
  statusPageTitle: {
    id: `${scope}.statusPageTitle`,
    defaultMessage: 'Expense reports',
  },
  approvalPageTitle: {
    id: `${scope}.approvalPageTitle`,
    defaultMessage: 'Expense approval',
  },
  travelRequestPageTitle: {
    id: `${scope}.travelRequestPageTitle`,
    defaultMessage: 'Create travel request',
  },
  travelStatusPageTitle: {
    id: `${scope}.travelStatusPageTitle`,
    defaultMessage: 'Travel requests',
  },
  travelApprovalsPageTitle: {
    id: `${scope}.travelApprovalsPageTitle`,
    defaultMessage: 'Travel approval',
  },
  travelDetailsPageTitle: {
    id: `${scope}.travelDetailsPageTitle`,
    defaultMessage: 'Travel details',
  },
})
